import MoreIcon from "@/assets/summary/more.svg?react";
import { ReactNode, useMemo } from "react";
import Popover from "@/component/PopoverRc";
import SelectionList from "@/component/SelectionList";
import "./index.less";
import recordStore from "@/store/record.store";
import RecordHelper from "@/bussiness/RecordHelper";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import fridayReporter from "@/utils/friday";

export interface ISpeakerPopoverProps {
  value: string;
  onChange: (name: string) => void;
}

const SpeakerPopover: React.FC<ISpeakerPopoverProps> = ({ value, onChange }) => {
  // 赶时间，先抄过来改改，直接引用了
  const speakerList = recordStore((state) => state.recentSpeakerList);

  const list = useMemo(() => {
    // 如果value在speakerList中，就把value放在第一个
    const speakerNamesList = speakerList.map((item) => item.speakerName[0]);
    const element = speakerList.find((item) => item.speakerName[0] === value);
    if (element && speakerNamesList.includes(value)) {
      return [
        element,
        ...speakerList.filter((item) => item.speakerName[0] !== value),
      ];
    }
    return speakerList;
  }, [speakerList, value]);

  const options = useMemo(() => {
    return [
      {
        id: "DELETE",
        label: "删除",
      },
    ];
  }, []);

  const handlSelectOptions = (item: { id: string; label: ReactNode }, name: string) => {
    if (item.id === "DELETE") {
      fridayReporter.pushData({
        eventCode: 'RecordPage_EditSpeaker_Delete'
      })
      RecordHelper.deleteSpeakerName([name]);
    }
  };

  const handleSelectRole = (val: string) => {
    onChange(val.trim());
  };

  return (
    <>
      {list.length > 0 && (
        <div className="w-60 p-2 pb-0">
          <div className="max-w-full h-62 overflow-y-hidden p-t-2 flex flex-col">
            <div className="text-mx-tertiary text-3.5 mb-1.5 text-left">{`最近发言人 (${list.length})`}</div>
            <div className="overflow-x-hidden overflow-y-auto flex-1">
              {list.map((item) => { 
                const speakerAvatarInfo = getSpeakerAvatarInfo(item.headImage);
                const name = item.speakerName[0];
                return (
                <div
                  key={name}
                  onClick={() => {
                    handleSelectRole(name);
                  }}
                  className={`speaker-item w-100% flex flex-row items-center justify-between cursor-pointer hover:bg-#F4F6F9 px-1 py-1 my-1 rounded-2.5 ${
                    name === value && "bg-[rgba(25,29,38,0.05)]"
                  }`}
                >
                  <div className="flex items-center">
                    <SpeakerAvatar
                      speakerName={name}
                      avatarIndex={speakerAvatarInfo.avatarIndex}
                      useDefaultAvatarIcon={item.useDefaultIcon}
                      className="size-8 mr-2 rounded-full"
                    />
                    <div className="flex-1 text-3.5 text-mx-secondary max-w-35 mx-text-ellipsis" title={name}>
                      {name}
                    </div>
                  </div>
                  <Popover
                    placement="topRight"
                    align={{ offset: [10, 0] }}
                    content={
                      <SelectionList
                        options={options}
                        onSelect={(option) => {
                          handlSelectOptions(option, name);
                        }}
                        stopPropagation
                      />
                    }
                  >
                    <div
                      className="more-icon size-6 ml-1 mr-2 flex items-center justify-center hover:bg-#ECEEF3 rounded-2"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <MoreIcon className="size-4" />
                    </div>
                  </Popover>
                </div>
              )})}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SpeakerPopover;
